enum PreferredTaxCardType {
  MAIN_CARD = 'Primary',
  SECONDARY_CARD = 'Secondary',
}
export default PreferredTaxCardType
